/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcInformationCircleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 17.9h1.5a.9.9 0 1 0 0-1.8h-.6V12a.897.897 0 0 0-.9-.9h-1.5a.9.9 0 0 0 0 1.8h.6v3.2h-.6a.9.9 0 0 0 0 1.8zm0-8.4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
      <path
        fillRule="evenodd"
        d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12M12 2.9a9.1 9.1 0 1 0 0 18.2 9.1 9.1 0 0 0 0-18.2"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcInformationCircleRegular;
